(() => {
  if (customElements.get('lookbook-slider')) {
    return;
  }

  class LookbookSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.options = {
        slidesPerView: 8,
        spaceBetween: 4,
        setWrapperSize: true,
        resistanceRatio: 0,
        breakpoints: {
          750: {
            spaceBetween: 11,
          }
        }
      };

      this.slider = new Swiper(this, this.options);

      if(this.closest('component-lookbook').hasAttribute('data-swipe')) {
        this.slider.on('touchMove', (s,e) => {
          if(s.swipeDirection === 'next') {
            this.closest('component-lookbook').removeAttribute('open');
          }
        })
      }
    }
  }

  customElements.define('lookbook-slider', LookbookSlider);
})();
